// Action Types
import {actionTypes} from '../action-types';

export const addAlias = aliasObject => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {
        aliasObject,
      },
      type: actionTypes.ALIAS_ADD,
    })
  );

export const deleteAlias = aliasId => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {
        aliasId,
      },
      type: actionTypes.ALIAS_DELETE,
    })
  );

export const deleteDone = ({status, error, id}) => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {
        status,
        error,
        id,
      },
      type: actionTypes.ALIAS_DELETE_DONE,
    })
  );

export const addDone = ({status, error, id}) => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {
        status,
        error,
        id,
      },
      type: actionTypes.ALIAS_ADD_DONE,
    })
  );
